import React from "react";

const ApplicationSuccessPage = () => {
  const type = window.location.hash.replace("#", "");
  return (
    <div className="td_success_wrapper">
      <div className="td_success_card">
        {/* Font Awesome Success Icon */}
        <div className="td_success_icon_wrapper">
          <i className="fa-regular fa-circle-check td_success_icon_fa"></i>
        </div>

        <h2 className="td_fs_32 td_bold td_heading_color td_mb_20">
          Application Submitted!
        </h2>

        <p className="td_fs_18 td_medium_color td_mb_50">
          Thank you for your interest in{" "}
          {type === "admission" ? "the undergraduate program" : "a postition"}{" "}
          at
          <strong> University of Nepal.</strong> After reviewing your
          application, we will contact you.
        </p>

        <a href="/" className="td_btn_primary">
          <i className="fa-solid fa-house"></i> Back to Home
        </a>
      </div>
    </div>
  );
};

export default ApplicationSuccessPage;
